import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

const CarouselComponent = (props) => {
    return (
        <div class="carousel-wrapper">
            <Carousel infiniteLoop useKeyboardArrows autoPlay showThumbs={false} >
                <div onClick={(e) => props.setImageFile(e.target.firstChild.src)}>
                    <img src="https://i.ibb.co/SQc6YqQ/Screen-Shot-2022-06-24-at-5-41-05-PM.png" alt='pokemon rat' />
                </div>
                <div onClick={(e) => props.setImageFile(e.target.firstChild.src)}>
                    <img src='https://i.ibb.co/TrqPtZn/Screen-Shot-2022-06-24-at-5-42-49-PM.png' alt='lotr' />
                </div>
                <div onClick={(e) => props.setImageFile(e.target.firstChild.src)}>
                    <img src='https://i.ibb.co/Kw99GvT/Screen-Shot-2022-06-24-at-2-29-34-PM.png' alt='bernie' />
                </div>
                <div onClick={(e) => props.setImageFile(e.target.firstChild.src)}>
                    <img src='https://i.ibb.co/3y2vmjF/Screen-Shot-2022-06-24-at-4-53-38-PM.png' alt='creepygirl' />
                </div>
                <div onClick={(e) => props.setImageFile(e.target.firstChild.src)}>
                    <img src='https://i.ibb.co/S3SfTk4/Screen-Shot-2022-06-24-at-5-42-27-PM.png' alt='matrix' />
                </div>
                <div onClick={(e) => props.setImageFile(e.target.firstChild.src)}>
                    <img src='https://i.ibb.co/znJ12VD/Screen-Shot-2022-06-24-at-5-41-54-PM.png' alt='invincible' />
                </div>
            </Carousel>
        </div>
    );
}

export default CarouselComponent;
